import ecommerce from './ecommerces';
import restServicesData from './restServices';
import shipping from './shipping';

const integrators = [...shipping, ...ecommerce, ...restServicesData];

export default integrators;
